import { Gradient, NumberConfig } from '../../Helper/types';

export interface HeaderBalance {
  image: string;
  amount?: number | string;
}

export interface dailyBonusBadgeProps {
  badgeCoverImage?: string;
  borderColor?: Gradient;
  font?: string;
  offerId?: any;
}

export interface HeaderProps {
  profilePicUrl: string;
  playerName?: string;
  profilePicBorder?: Gradient;
  logoPicUrl: string;
  openLogoutModal: () => void;
  overrideStore: () => void;
  logoSize?: string;
  balances?: HeaderBalance[];
  balanceQuantityFormat?: NumberConfig;
  preview?: boolean;
  fontFamily?: string;
  showHeader?: boolean;
  balanceTheme?: EBalancesTheme;
  profileFrameImg?: string;
  backgroundColor?: string;
  fullWidth?: boolean;
  playerLevelImg?: string;
  dailyBonusBadges?: dailyBonusBadgeProps[];
  timer?: string;
  onClickBadge?: (offerId?: string) => void;
}

export enum EBalancesTheme {
  DEFAULT = 'default',
  BAGELCODE = 'bagelcode',
  SPACEGO = 'spacego',
  PRODUCT_MADNESS = 'product-madness',
  ME2ON = 'me2on',
  PLAY_SIMPLE = 'play-simple',
  PIPA = 'pipa',
}
